import React from "react";
import {Col, Row} from "antd";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, Banner } from "@reco-w/core-ui";
import { Namespaces, yunqiModel } from "@reco-w/yunqi-models";
import { BackTopBox } from "@reco-w/about-e";

export namespace YunQi {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> {}

    export interface IState extends ViewComponent.IState, yunqiModel.StateType {}

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.yunqi;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/yunqi`);
        }
        componentDidMount() {
            this.dispatch("input", { honorIndex: 5});
            this.scalePage();
            $(window).resize(() => {
                return this.scalePage();
            });
            $(".box-type2 ul li").hover(
                function() {
                    let idx = $(this).index();
                    $(".bi-project-list").each(function() {
                        if ($(this).index() === idx) $(this).show();
                        else $(this).hide();
                    });
                },
                function() {}
            );
        }
        scalePage() {
            const width = document.documentElement.clientWidth;
            if (width < 770) {
                this.dispatch("input", { honorIndex: 1});
            } else {
                this.dispatch("input", { honorIndex: 5 });
            }
        }


        renderResource() {
            return (
                <div className="block-content company-content">
                    <div className="container">
                        <div className="second-title">
                            <span>了解云企</span>
                        </div>
                        <div className="company-info">
                            瑞谷云企成立于2020年，依托瑞谷集团数字化基因和产业园区服务体系，为政府园区提供数字化精准招商解决方案。瑞谷云企以投资可能性模型和产业链优选模型两大算法模型，开发获取一手、真实、精准的投资选址项目，并通过全流程数字化管理和全程跟踪服务，聚焦并推动优质企业投资落地，助力政府解决招商实际问题，帮助地方构筑产业集聚生态，推动城市经济发展和技术创新。
                        </div>
                    </div>
                </div>
            )
        }

        renderSystem() {
            const zsData = [
                {
                    title: "委托招商",
                    desc: "工厂选址、总部选址、外资选址"
                },
                {
                    title: "招商推介会",
                    desc: "企业邀约、会务承办、活动宣传"
                },
                {
                    title: "选址服务日",
                    desc: "政企面对面交流平台"
                },
                {
                    title: "委托运营",
                    desc: "一站式托管运营服务"
                },
                {
                    title: "企业数据治理",
                    desc: "智能洞察企业动向"
                },
                {
                    title: "招商平台",
                    desc: "数字化管理系统"
                }
            ]
            return (
                <div className="block-content attract-content">
                    <div className="container" style={{overflow:"visible"}}>
                        <div className="second-title">
                            <span>产业招商</span>
                        </div>
                        <div className="company-info">
                            瑞谷云企服务政府园区，成立<span className="primary-color">专属招商服务团队</span>。以投资可能性模型和产业链优选模型两大算法模型，开发获取<span className="primary-color">一手、真实、精准</span>的投资选址项目，并通过全流程数字化管理和全程跟踪服务，聚焦并推动优质企业投资落地，助力政府解决招商实际问题，帮助地方构筑产业集聚生态，推动城市经济发展和技术创新。
                        </div>
                        <Row gutter={[20,20]} className='mt30 attract-row'>
                            {
                                zsData.map((item, i) => {
                                    return (
                                        <Col xs={12} sm={12} md={12} xl={8} key={i}>
                                            <div className="attract-item" onClick={() => window.open("https://serpark.cn/entrust")}>
                                                <div className="attract-item-title">{item.title}</div>
                                                <div className="attract-item-desc">{item.desc}</div>
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                </div>
            )
        }
        renderCompany() {
            const zsData = [
                {
                    title: "企业选址",
                    desc: "企业邀约、会务承办、活动宣传"
                },
                {
                    title: "企业上云",
                    desc: "阿里云、华为云"
                },
                {
                    title: "大厂生态",
                    desc: "帮助企业进入大厂生态体系"
                },
                {
                    title: "投融资",
                    desc: "帮助企业解决融资难题"
                },
                {
                    title: "法律咨询",
                    desc: "提供专业企业法律服务"
                },
                {
                    title: "财税服务",
                    desc: "提供安全可靠的财税咨询"
                }
            ]
            return (
                <div className="block-content">
                    <div className="container" style={{overflow:"visible"}}>
                        <div className="second-title">
                            <span>企业服务</span>
                        </div>
                        <div className="company-info">
                            瑞谷云企服务企业，成立专属企服团队。建立以企业诉求为根本价值导向的运营模式，满足企业投资、金融、渠道、云平台、成本控制、法律、财税、产业发展等多方面的需求，提供<span className="primary-color">“全链条”</span>运营服务，帮助企业<span className="primary-color">提高运营效率、降低运营成本</span>。
                        </div>
                        <Row gutter={[20,20]} className='mt30 attract-row'>
                            {
                                zsData.map((item, i) => {
                                    return (
                                        <Col xs={12} sm={12} md={12} xl={8} key={i}>
                                            <div className="attract-item" onClick={() => window.open("https://serpark.cn/selection")}>
                                                <div className="attract-item-title">{item.title}</div>
                                                <div className="attract-item-desc">{item.desc}</div>
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                </div>
            )
        }

        renderBody() {
            return (
                <>
                    <div className="content">
                        <Banner.Component extraClass="large" bimg="assets/images/guanw/rgyq-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1">瑞谷云企</div>
                                <div className="banner-text-name2 mt25">
                                    <span>大数据</span><span className="margin-left-xl">真项目</span>
                                </div>
                            </div>}
                        />
                        {this.renderResource()}
                        {this.renderSystem()}
                        {this.renderCompany()}


                        {this.renderEmbeddedView(BackTopBox.Page)}
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.yunqi]);
}
